import { connect } from 'react-redux';

import HomePage from './component';

const mapStateToProps = (state, { baseUrl, propertyId, listing, location }: any) => ({
  baseUrl,
  propertyId,
  listing,
  location,
  clusterSettings: state.app.clusterSettings,
  propertyStore: state.payments.landlord.property,
  onboarding: state.payments.landlord.onboarding,
  config: state.payments.landlord.config,
});

export default connect(mapStateToProps)(HomePage);
